import { render, staticRenderFns } from "./AdviceDutyBloc.vue?vue&type=template&id=6421fc0a&scoped=true&"
import script from "./AdviceDutyBloc.vue?vue&type=script&lang=js&"
export * from "./AdviceDutyBloc.vue?vue&type=script&lang=js&"
import style0 from "./AdviceDutyBloc.vue?vue&type=style&index=0&id=6421fc0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6421fc0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/35827007/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6421fc0a')) {
      api.createRecord('6421fc0a', component.options)
    } else {
      api.reload('6421fc0a', component.options)
    }
    module.hot.accept("./AdviceDutyBloc.vue?vue&type=template&id=6421fc0a&scoped=true&", function () {
      api.rerender('6421fc0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/option/AdviceDutyBloc.vue"
export default component.exports